module.exports = __webpack_public_path__ + "img/obch7.f08fe67d.svg";